<h1>Songs matching: &ldquo;{{searchQuery()}}&rdquo;</h1>
<p>Play a song or click <mat-icon>queue_music</mat-icon> to add it to your favourites. <app-player-mode-toggle /></p>

<br />

<div class="content">
  @if (loading()) {
  <p>Searching&hellip;</p>
  } @else if (results().length === 0) {
  <mat-card>
    <mat-card-content>
      <p>No songs found.</p>
    </mat-card-content>
  </mat-card>
  } @else {
  @for (t of results(); track t.id) {
  <mat-card class="song-card">
    <mat-card-content class="song-row">
      <img class="cover" [src]="t.album.images[2]?.url || t.album.images[0]?.url" alt="album cover"
        [routerLink]="['/album', t.album.id]" />
      <div class="song-info">
        <strong class="song-name" [title]="t.name">{{t.name}}</strong>
        <span class="song-meta">
          @for (a of t.artists; track a.id) {
          <a [routerLink]="['/artist', a.id]">{{a.name}}</a><app-favourite-heart size="small" [saved]="artistFavourites.ids().has(a.id)"
            [name]="a.name" list="Favourite Artists" (toggled)="artistFavourites.toggle(a.id, a.name)" />{{!$last ? ', ' : ''}}
          }
          &middot; <a [routerLink]="['/album', t.album.id]">{{t.album.name}}</a>
          &middot; {{(t.duration_ms / 60000).toFixed(2)}} min
        </span>
        <app-track-player [trackId]="t.id" [previewUrl]="t.preview_url" />
      </div>
      <div class="song-actions">
        <button mat-icon-button (click)="addFavourite(t)" title="Add to Favourites">
          <mat-icon>queue_music</mat-icon>
        </button>
        <app-deezer-link kind="track" [id]="t.id" [name]="t.name" />
      </div>
    </mat-card-content>
  </mat-card>
  }
  }
</div>
